import { Outlet } from 'react-router';
import { BookingSheet } from '@/features/booking/BookingSheet';
import { BottomNav } from './BottomNav';
import { useStudioData } from './StudioContext';

export function ClientLayout() {
  const studio = useStudioData();
  return (
    <>
      <main id="studio-main" className="with-bottom-nav">
        <Outlet />
      </main>
      <BottomNav slug={studio.slug} />
      <BookingSheet studio={studio} />
    </>
  );
}
